import TextAreaComponent from "./TextAreaComponent";

export default TextAreaComponent;
